import React, { useEffect } from "react";
import { Cesium3DTileset } from "cesium";

export const AddGoogleMapsApi = ({ rfcs }) => {
  useEffect(() => {
    if (rfcs.current && rfcs.current.cesiumElement) {
      // Add 3D Tiles tileset.
      const tileset = rfcs.current.cesiumElement.scene.primitives.add(
        new Cesium3DTileset({
          // google
          url: "https://tile.googleapis.com/v1/3dtiles/root.json?key=AIzaSyBH8BFx6cwCSkfMrh_TNnCtt7M5QgGhddA",
          showCreditsOnScreen: true,

          // plateau
          // url: "https://assets.cms.plateau.reearth.io/assets/11/6d05db-ed47-4f88-b565-9eb385b1ebb0/13100_tokyo23-ku_2022_3dtiles%20_1_1_op_bldg_13101_chiyoda-ku_lod1/tileset.json",

        })
      );

      return () => {
        rfcs.current.cesiumElement.scene.primitives.remove(tileset);
      };
    }
  }, []);
  return <></>;
};
